"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SynRecycleBinView = void 0;
const tslib_1 = require("tslib");
require("../../../../TdWebtoolkitControls/controls/List/List");
const Utilities_1 = require("../../../javascript/Utilities");
require("../../ErrorDialog/ErrorDialog.js");
const Instance_1 = require("../../../model/Instance");
const List_1 = require("../../../../TdWebtoolkitControls/controls/List/List");
class SynRecycleBinView {
    static RefreshAsync(configData, $list) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield $list.synList("refreshAsync");
        });
    }
    static EnableDisableControls(configData, m_$list) {
        let selectedIds = m_$list.synList("getSelectedIds");
        if (selectedIds) {
            if (selectedIds.length > 0)
                $("#" + configData.unDeleteButtonId).removeAttr("disabled");
            else
                $("#" + configData.unDeleteButtonId).attr("disabled", "disabled");
        }
        else
            $("#" + configData.unDeleteButtonId).attr("disabled", "disabled");
    }
}
exports.SynRecycleBinView = SynRecycleBinView;
exports.default = {
    selCount: -1,
    impl: (ids, parentId, relId, completedHandler) => {
        let that = this;
        require.ensure(["../../../templates/cefunc_228.less"], (require) => {
            let cefunc_184_less = require("../../../templates/cefunc_228.less");
            let markup = require("../../../templates/cefunc_228.tmpl.html");
            let wndData = Utilities_1.synUtil.popupWindow({
                actions: ["Maximize", "Close"],
                width: 800,
                height: 600,
                synDesktopAware: true,
                modal: true,
                title: Utilities_1.synUtil.Strings.getValue("cefunc.228"),
                resizable: true
            });
            let configData = {
                synUtil: Utilities_1.synUtil,
                windowID: "popup_" + wndData.guid,
                unDeleteButtonId: "unDeleteButtonId_" + wndData.guid,
                refreshButtonId: "refreshButtonId_" + wndData.guid,
                closeButtonId: "closeButtonId_" + wndData.guid
            };
            // Create HTML from template
            let template = kendo.template(markup);
            wndData.contentDiv.html(template(configData));
            that.m_$list = $("#docsDeleted");
            that.m_$list.on("initSuccess", function (evt) {
                SynRecycleBinView.RefreshAsync(configData, that.m_$list);
            });
            that.m_$list.on("selectionChanged", function (evt) {
                SynRecycleBinView.EnableDisableControls(configData, that.m_$list);
            });
            that.m_$list
                .on("beginDataBinding", () => {
                Utilities_1.synUtil.beginAjaxProgress($("#" + configData.refreshButtonId));
            })
                .on("endDataBinding", () => {
                Utilities_1.synUtil.endAjaxProgress($("#" + configData.refreshButtonId));
            })
                .synList({
                columnOptions: {
                    layoutName: "cefunc.228",
                    catIdDependent: true,
                    catId: 1
                },
                dataItemGenerator: (ctx) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
                    let strDays = Utilities_1.synUtil.Configs.getValue("undeletedayspan");
                    let iDays = Number(strDays);
                    if ((isNaN(iDays)) || (iDays <= 0))
                        strDays = "05";
                    let searchInstance = yield Instance_1.Instance.fromSearchData({
                        "cgdocument.typeid": "1",
                        "cgexplorer.childs": "Y",
                        "cgdocument.deleted": "Y",
                        "cgdocument.deleteddate": ">=#variable.currentdatetime#MINUS" + strDays + "-00-0000 00:00:00"
                    });
                    return new Promise((resolve) => {
                        Utilities_1.synUtil.getAJAXData({
                            method: "POST",
                            url: Utilities_1.synUtil.getWSUrl("Search"),
                            requestData: {
                                query: JSON.stringify(searchInstance.toJSON()),
                                adminSearch: true
                            },
                            done(resultsId, textStatus, jqXHR, handlerKey) {
                                let url = Utilities_1.synUtil.getWSUrl("Results") + resultsId;
                                let headers = {};
                                if (handlerKey)
                                    headers["X-WS-Affinity"] = handlerKey;
                                Utilities_1.synUtil.getAJAXData({
                                    method: "POST",
                                    url,
                                    headers,
                                    requestData: {
                                        fieldNames: JSON.stringify(ctx.columnNames),
                                        oneShot: false
                                    },
                                    done: (data) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                                        if (!data.total)
                                            Utilities_1.synUtil.Notifications.warning(Utilities_1.synUtil.Strings.getValue("searchnoresults"));
                                        else if (data.moreRowsAvailable)
                                            Utilities_1.synUtil.Notifications.info(Utilities_1.synUtil.Strings.getValue("qrymoreresultsavailablet"));
                                        const instances = yield Instance_1.Instance.fromJSONArray(data.data);
                                        resolve(List_1.instancesToListDataItems(instances));
                                    })
                                });
                            }
                        });
                    });
                })
            });
            // Undelete click event
            $("#" + configData.unDeleteButtonId).on("click", function () {
                let selectedIds = that.m_$list.synList("getSelectedIds");
                if (selectedIds) {
                    if (selectedIds.length > 0) {
                        let btnUndeleteButton = $("#" + configData.unDeleteButtonId);
                        Utilities_1.synUtil.beginAjaxProgress(btnUndeleteButton);
                        Utilities_1.synUtil.executeMethod({
                            method: "cefunc.227",
                            ids: selectedIds,
                            parentId,
                            relId,
                            additionalData: {},
                            adminSearch: true,
                            done() {
                                Utilities_1.synUtil.endAjaxProgress(btnUndeleteButton);
                                SynRecycleBinView.RefreshAsync(configData, that.m_$list);
                                Utilities_1.synUtil.Notifications.success(Utilities_1.synUtil.Strings.getValue("documentsundeleted"));
                            },
                            fail(jqXHR, textStatus, errorThrown, url) {
                                Utilities_1.synUtil.endAjaxProgress(btnUndeleteButton);
                                Utilities_1.synUtil.getAJAXDataFail(jqXHR, textStatus, errorThrown, this.url, true);
                            }
                        });
                    }
                }
            });
            // Refresh click event
            $("#" + configData.refreshButtonId).on("click", function () {
                SynRecycleBinView.RefreshAsync(configData, that.m_$list);
            });
            // Close button click event
            $("#" + configData.closeButtonId).on("click", function () {
                if (typeof window.synDesktopApp !== "undefined")
                    window.synDesktopApp.endDialog("0");
                else
                    $("#" + configData.windowID).data("kendoWindow").close();
            });
        });
    }
};
